import axios from 'axios';
import { api, headers } from '../../app/conf';
import { makeQuery } from '../../shared/helpers/commons';

export const getProfiles = (filters, token) => axios({
    method: 'get',
    url: `${api}/profiles?${makeQuery(filters)}`,
    headers: {
        ...headers,
        "X-Access-Token": token,
        persistResponse: true
    }
});
